<!--
 * @Author: cts 308360781@qq.com
 * @Date: 2025-06-22 18:56:07
 * @LastEditors: cts 308360781@qq.com
 * @LastEditTime: 2025-06-22 18:57:04
 * @FilePath: \web2\src\views\yunke\project\query.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
    <div>

    </div>
</template>

<script>
    export default {
        data() {
            return {
            }
        },
        created () {
            
        },
        methods: {
           
        },
    }
</script>

<style scoped>

</style>
